module.exports = __webpack_public_path__ + "img/showcase-hotsheet-fr-ca.87c361e8.jpg";